import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import HubSpotCompanyList from "./HubSpotCompanyList";
import { ModalPickerProps } from "../props";

const HubSpotCompanyModalPicker = (props: ModalPickerProps<server.dto.HubSpotCompany>) => {

  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={"Link HubSpot company"}
    modalTitle={"HubSpot companies"}
    modalSize="mini"
    renderModalContent={(closeModal) => <HubSpotCompanyList
      onItemSelected={(company) => {
        closeModal();
        props.onChange(company);
      }}
    />}
    renderRemovable={() => <></>}

    {...props}
  />;
};

export default HubSpotCompanyModalPicker;